<template>
  <div class="activityClientList">
    <!-- <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportType :wayString="wayString" :placehold="placehold" :Title="Title"></reportType>
      </el-main>
    </PageNav> -->
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mr10">
          <span class="fs14 color-666">{{
            $t("views.Analysisreport.channelPerfReport.51h4zb879d40")
          }}</span>
          <div class="select-box" style="width: 240px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelPerfReport.51h4zb87asw0')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87b7w0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87bk00')
              "
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
                <div class="lines ml16 mr16"></div>
        <div class="flex-al">
          <!-- <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51yzwntly2o0")
          }}</span> -->
          <div class="select-box" style="width:170px;">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="lines ml16 mr16"></div>
        <div class="select-box flex-al">
          <el-select
            filterable
            clearable
            style="width: 180px"
            @change="search"
            v-model="filter.client_tracestatus"
            placeholder="请选择客户状态"
          >
            <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
            <!-- <el-option :label="$t('Common.options')" value></el-option> -->
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')" value="0"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')" value="1"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')" value="2"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')" value="3"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')" value="4"></el-option>
            <el-option
              :label="$t('Customersmanage.bvN1')"
              value="6"
            ></el-option>
            <el-option
              :label="$t('Customersmanage.bvN2')"
              value="7"
            ></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')" value="-1"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')" value="-2"></el-option>
          </el-select>
        </div>
        <div class="lines ml16 mr16"></div>
        <div class="flex-al Inquire-box">
          <div class="ipt-box" style="width: 250px">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="请输入招生活动名称"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
// import reportType from "../../components/report/reportType5";
import reportPageTemp from "@/components/report/reportTemp";
import storeanalysisreport from "./analysisreport.js";
export default {
  name: "analysisreport-activityClientList",
  data() {
    return {
      openMenu: ["8"],
      reportParams: {
        wayString: "activityClientList", //传递到子组件的方法名称
        Title: "活动名单明细报表",
      },

      //筛选
      filter: {
        rang_time: "", //选择时间--必须定义为这个参数
        starttime: "",
        endtime: "",
        client_tracestatus: "",
        keyword: "",
                coursetype_id: "", //班组

        // frommedia_name: "", //渠道类型
        // channel_id: "", //渠道明细
      },
      // 筛选的下拉列表
      filterList: {
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
                coursetypeList: [], //班组-下拉数据

      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    PageNav,
    // reportType,
    reportPageTemp,
  },
  created() {
    this.filter.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    (this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate),
      (this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate);
          this.courseTypeApi();

  },
  mounted() {},
  methods: {
        //下拉列表->获取班组列表--zjb
    courseTypeApi() {
      storeanalysisreport.courseTypeApi({}).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
    //检索
    search() {
      this.filter.starttime = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.endtime = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("analysisreport.less");
.activityClientList {
  // height: 100vh;
  font-size: 20px;
}
</style>
